module.exports = __webpack_public_path__ + "img/Location.15c844d5.svg";